<mat-card>
  <mat-card-header>
    <mat-icon mat-card-avatar>handyman</mat-icon>
    <mat-card-title>Siden er under ombygning</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <p>Vi arbejder på at opdatere indholdet på denne side, så det er mere tidssvarende.</p>
  </mat-card-content>
</mat-card>
